import { connect } from "react-redux";
import { verifyPermission } from "helpers/permission";

const PermissionGuard = ({
  userPermissions,
  permissions,
  children,
  fallback = null,
}) => {
  const hasPermission = permissions.some((permission) =>
    verifyPermission(userPermissions, permission)
  );

  return hasPermission ? children : fallback;
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(PermissionGuard);
